import { createReducer } from 'helpers/ReducerUtil'
import {
  CLEAR_WORKFLOW_HISTORY,
  UPDATE_APPROVER_HISTORY,
  UPDATE_WORKFLOW_HISTORY,
} from './constants'

const updateHistory = (history, action) => action.history ? [...action.history] : []

const approverHistoryReducer = createReducer([], {
  [CLEAR_WORKFLOW_HISTORY]: () => [],
  [UPDATE_APPROVER_HISTORY]: updateHistory,
})

const workflowHistoryReducer = createReducer([], {
  [CLEAR_WORKFLOW_HISTORY]: () => [],
  [UPDATE_WORKFLOW_HISTORY]: updateHistory,
})

export {
  approverHistoryReducer,
  workflowHistoryReducer,
}
